import React from 'react';
import PropTypes from 'prop-types';

import { Group, LegalInfoWrapper, FormGroupWrapper, Label } from './Components';
import Button from '../../components/Button';
import TwoGroup from '../../components/TwoGroup';
import { OnSubmitValidator } from '../../containers/DefaultStyles/FormDetails';
import { LoadingSpinner } from '../../components/LoadingSpinner';

import GetUpdatesCheckbox from '../Widget/GetUpdatesCheckbox';

import { copyFor, capitalization } from '../../copy/copy';
import submissionErrorHandler from '../../utils/submissionErrorHandler';

const defaultOptInText = isCare2 =>
    isCare2 ? 'Action Button and Care2' : 'Action Button';

const SubscribeLabel = props => (                
    <Label>
        {!!props.subscriptionOptInText
            ? props.subscriptionOptInText
            : props.isEU
            ? copyFor('formFields', 'updatesMultipleEU')
            : copyFor(
                  'formFields',
                  'updatesEmail',
                  undefined,
                  capitalization.eachWord
              )}
    </Label>);

const OptInsAndButtonGroup = props => (
    <Group isSubmitting={props.isSubmitting}>
        {props.actionType === 'petition' && 
        <SubscribeLabel subscriptionOptInText={props.subscriptionOptInText} isEU={props.isEU} />}
        <TwoGroup>
            <LegalInfoWrapper
                style={{ flex: 0.75 }}
                wide={props.actionType === 'opinion' && props.partnerOptIn && props.hasABOptIn}
            >
                {props.actionType === 'opinion' && 
                <SubscribeLabel subscriptionOptInText={props.subscriptionOptInText} isEU={props.isEU} />}
                {props.partnerOptIn && (
                    <FormGroupWrapper>
                        <GetUpdatesCheckbox
                            name="partnerOptIn"
                            labelText={props.partnerOptInText}
                            keepExistingCapitalization={true}
                        />
                    </FormGroupWrapper>
                )}
                {props.hasABOptIn && (
                    <FormGroupWrapper>
                        <GetUpdatesCheckbox
                            labelText={
                                props.getUpdatesText || defaultOptInText(props.isCare2)
                            }
                            keepExistingCapitalization={true}
                        />
                    </FormGroupWrapper>
                )}
            </LegalInfoWrapper>
            <OnSubmitValidator
                style={{ position: 'relative' }}
                onClick={e => {
                    e.preventDefault();
                    let errors = submissionErrorHandler(
                        props.currentFormValues,
                        props.validate
                    );
                    if (props.actionType === 'opinion'){
                        errors = errors.filter(error => !props.opinionNotRequiredFields.error);
                    };
                    if (errors.length === 0 && !props.invalid) {
                        props.setValidState(true);
                        props.clearSubmitErrors();
                        props.onSubmit();
                    } else {
                        props.setSubmitErrors(errors);
                    }
                }}
            >
                <Button
                    scale
                    primary={true}
                    label={props.buttonText}
                    type="submit"
                    className="submitButton"
                    isSubmitting={props.isSubmitting}
                    disabled={props.invalid}
                    style={{
                        position: 'absolute',
                        top: '0',
                        width: '100%'
                    }}
                />
                <LoadingSpinner />
            </OnSubmitValidator>
        </TwoGroup>
    </Group>
);

OptInsAndButtonGroup.propTypes = {
    buttonText: PropTypes.string.isRequired,
    clearSubmitErrors: PropTypes.func.isRequired,
    currentFormValues: PropTypes.object,
    getUpdatesText: PropTypes.string,
    hasABOptIn: PropTypes.bool.isRequired,
    invalid: PropTypes.bool,
    isCare2: PropTypes.bool,
    isEU: PropTypes.bool.isRequired,
    isSubmitting: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
    partnerOptIn: PropTypes.bool.isRequired,
    partnerOptInText: PropTypes.string,
    setSubmitErrors: PropTypes.func.isRequired,
    setValidState: PropTypes.func.isRequired,
    subscriptionOptInText: PropTypes.string,
    validate: PropTypes.func.isRequired
};

export default OptInsAndButtonGroup;
